import(/* webpackMode: "eager" */ "/codebuild/output/src2614373214/src/actions-runner/_work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
